import React from 'react';

export default class PortfolioItem extends React.Component{


    constructor(props) {
        super(props);
        this.state = {deps:[], Mymodal: false}
    }

    mensagem = (texto) => {
        console.log(texto);
    }

    render(){

        return(

                        <div className="col-md-3 col-lg-3">
                            <div className="portfolio-item mx-auto">
                                <img onClick={() => this.mensagem(this.props.alt)} className="img-fluid" src={process.env.PUBLIC_URL+"/portfolio/"+this.props.image} alt={this.props.alt} title={this.props.title}/>
                            </div>
                        </div>

        );
    }
}